module.exports = __webpack_public_path__ + "static/media/orders.6f958f07.svg";